/* eslint-disable max-len */
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonSharedModule } from '@common/shared/common-shared.module';
import { MATERIAL_MODULES, CDK_MODULES } from './material-modules';

import { BitfMatOkCancelDialogComponent } from '@common/libs/bitforce/core/components/ui/ok-cancel-dialog/material/bitf-mat-ok-cancel-dialog.component';
import { BitfLoaderComponent } from '@bitf/core/components/ui/loader/bitf-loader.component';
import { BitfMatLoaderComponent } from '@bitf/core/components/ui/loader/material/bitf-mat-loader/bitf-mat-loader.component';
import { BitfCurrencyPipe } from '@common/libs/bitforce/pipes/bitf-currency.pipe';

// import { BitfMatFormItemComponent } from '@common/libs/bitforce/core/components/ui/form-item/material/mat-form-item/bitf-mat-form-item.component';
// import { BitfMatFormOptionComponent } from '@common/libs/bitforce/core/components/ui/form-item/material/mat-form-option/bitf-mat-form-option.component';
// import { BitfMatSearchComponent } from '@common/libs/bitforce/core/components/ui/search/material/bitf-mat-search.component';
// import { BitfMatSortComponent } from '@common/libs/bitforce/core/components/ui/sort/material/bitf-mat-sort.component';

// import { BitfFormItemContainerComponent } from '@common/libs/bitforce/core/components/ui/form-item/bitf-form-item-container/bitf-form-item-container.component';
// import { BitfMatPaginatorComponent } from '@bitf/core/components/ui/paginator/material/bitf-mat-paginator.component';
// import { BitfUiRoleManagerDirective } from '@common/libs/bitforce/directives/ui-role-manager/bitf-ui-role-manager.directive';
// import { BitfTouchEventDirective } from '@common/libs/bitforce/directives/bitf-touch-events/bitf-touch-event.directive';

// import { BitfDatePipe } from '@common/libs/bitforce/pipes/bitf-date.pipe';
import { DatePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { DateAdapterService } from '@web/core/services/date-adapter.service';

// import { BitfJoinArrayPipe } from '@common/libs/bitforce/pipes/bitf-join-array.pipe';

import { VehicleGalleryComponent } from './vehicle-gallery/vehicle-gallery.component';
import { VehicleGalleryDialogComponent } from './vehicle-gallery-dialog/vehicle-gallery-dialog.component';
import { VehicleCardComponent } from './vehicle-card/vehicle-card.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { VehicleCalculatorComponent } from './vehicle-calculator/vehicle-calculator.component';
import { VehicleBuyButtonComponent } from './vehicle-buy-button/vehicle-buy-button.component';
import { ContactsFormComponent } from './contacts-form/contacts-form.component';
import { ActivateInvestmentDialogComponent } from './activate-investment-dialog/activate-investment-dialog.component';
import { BitfMatLanguageSelectorComponent } from '@common/libs/bitforce/core/components/ui/language-selector/material/bitf-mat-language-selector.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { NewsletterDialogComponent } from './newsletter-dialog/newsletter-dialog.component';
import { ImageComponent } from './image/image.component';

const SHARED_MODULES = [CommonSharedModule, RouterModule, MATERIAL_MODULES, CDK_MODULES];
const SHARED_COMPONENTS = [
  BitfLoaderComponent,
  // BitfMatPaginatorComponent,
  // BitfUiRoleManagerDirective,
  // BitfTouchEventDirective,
  BitfMatOkCancelDialogComponent,
  BitfMatLoaderComponent,
  // BitfMatFormOptionComponent,
  // BitfMatFormItemComponent,
  // BitfMatSearchComponent,
  // BitfMatSortComponent,
  // BitfFormItemContainerComponent,
  BitfMatLanguageSelectorComponent,
  VehicleGalleryComponent,
  VehicleGalleryDialogComponent,
  VehicleCardComponent,
  VehicleDetailsComponent,
  VehicleCalculatorComponent,
  VehicleBuyButtonComponent,
  ContactsFormComponent,
  ActivateInvestmentDialogComponent,
  NewsletterComponent,
  MaintenanceComponent,
  NewsletterDialogComponent,
  ImageComponent,
];
const SHARED_DIRECTIVES = [];
const SHARED_PIPES = [
  BitfCurrencyPipe,
  // BitfDatePipe,
  // BitfJoinArrayPipe
];
const SHARED_PROVIDERS = [DatePipe, { provide: DateAdapter, useClass: DateAdapterService }];

@NgModule({
  imports: [...SHARED_MODULES],
  exports: [...SHARED_MODULES, ...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
  declarations: [...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [...SHARED_PROVIDERS],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
